import { render } from "./PaymentMethodSelect.vue?vue&type=template&id=c116adb4&scoped=true"
import script from "./PaymentMethodSelect.vue?vue&type=script&lang=js"
export * from "./PaymentMethodSelect.vue?vue&type=script&lang=js"

import "./PaymentMethodSelect.vue?vue&type=style&index=0&id=c116adb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c116adb4"]])

export default __exports__